import script from "./SfHeader.vue?vue&type=script&setup=%7Bname%3A%20'SfHeader'%7D&lang=ts"
export * from "./SfHeader.vue?vue&type=script&setup=%7Bname%3A%20'SfHeader'%7D&lang=ts"

import "./SfHeader.vue?vue&type=style&index=0&id=6bfc3bdb&scoped=true&lang=less"

import exportComponent from "/app/10119217139/workspace/IBU-IFSP_PUBLIC/IBU-IFSP-OPENAPI/OPENAPI_WEB_PORTAL_BUILD_GKE_DIRECT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bfc3bdb"]])

export default __exports__